module.exports = __webpack_public_path__ + "img/enhanced-dollar-none.65b217db.svg";